import React, {
  useMemo,
  useState
} from "react";
import { gql, useQuery } from "@apollo/client";

const GET_PEDIDOS = gql`
  query getPedidosUltimos30Dias {
    getPedidos {
      _id
      fecha
      productos
    }
  }
`;

const GET_PRODUCTOS = gql`
  query GetProductos {
    getProductos {
      _id
      nombre
      proveedores
    }
  }
`;

function Proveedores() {
  // =========================
  // INPUT
  // =========================
  const [inputBusqueda, setInputBusqueda] =
    useState("");

  // =========================
  // BUSQUEDA REAL
  // =========================
  const [busqueda, setBusqueda] =
    useState("");

  // =========================
  // PEDIDOS
  // =========================
  const {
    loading: loadingPedidos,
    error: errorPedidos,
    data: dataPedidos
  } = useQuery(GET_PEDIDOS);

  // =========================
  // PRODUCTOS
  // =========================
  const {
    loading: loadingProductos,
    error: errorProductos,
    data: dataProductos
  } = useQuery(GET_PRODUCTOS);

  // =========================================================
  // PROCESAR PRODUCTOS
  // =========================================================
  const productosStats = useMemo(() => {
    if (!dataPedidos?.getPedidos)
      return [];

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    const hace30dias = new Date(hoy);
    hace30dias.setDate(
      hoy.getDate() - 29
    );

    const productosMap = {};

    dataPedidos.getPedidos.forEach(
      (pedido) => {
        const fecha = new Date(
          pedido.fecha
        );

        fecha.setHours(
          fecha.getHours() - 5
        );

        const diffDias = Math.floor(
          (hoy - fecha) /
            (1000 * 60 * 60 * 24)
        );

        const productos = JSON.parse(
          pedido.productos || "[]"
        );

        productos.forEach((p) => {
          const nombre = p.nombre;

          // Buscar producto real
          const productoDB =
            dataProductos?.getProductos?.find(
              (prod) =>
                prod.nombre === nombre
            );

          const proveedores =
            productoDB?.proveedores ||
            [];

          // ====================================
          // FILTRO SOLO CON ENTER
          // ====================================
          const textoBusqueda =
            busqueda.toLowerCase();

          const coincideProveedor =
            Array.isArray(
              proveedores
            )
              ? proveedores.some((prov) =>
                  prov
                    ?.toLowerCase()
                    .includes(
                      textoBusqueda
                    )
                )
              : proveedores
                  ?.toLowerCase()
                  .includes(
                    textoBusqueda
                  );

          if (
            busqueda &&
            !coincideProveedor
          ) {
            return;
          }

          // Crear producto
          if (!productosMap[nombre]) {
            productosMap[nombre] = {
              nombre,
              proveedores,
              mensual: 0,
              semanal: 0
            };
          }

          // =========================
          // MENSUAL
          // =========================
          if (fecha >= hace30dias) {
            productosMap[nombre].mensual +=
              Number(p.cantidad || 0);
          }

          // =========================
          // SEMANAL
          // =========================
          if (diffDias <= 6) {
            productosMap[nombre].semanal +=
              Number(p.cantidad || 0);
          }
        });
      }
    );

    return Object.values(productosMap);
  }, [
    dataPedidos,
    dataProductos,
    busqueda
  ]);

  // =========================
  // LOADING
  // =========================
  if (
    loadingPedidos ||
    loadingProductos
  ) {
    return <p>Cargando...</p>;
  }

  // =========================
  // ERROR
  // =========================
  if (errorPedidos) {
    return (
      <p>
        Error pedidos:{" "}
        {errorPedidos.message}
      </p>
    );
  }

  if (errorProductos) {
    return (
      <p>
        Error productos:{" "}
        {errorProductos.message}
      </p>
    );
  }

  return (
    <div style={{ padding: 20 }}>
      {/* ================================= */}
      {/* INPUT BUSQUEDA */}
      {/* ================================= */}
      <div
        style={{
          marginBottom: 25
        }}
      >
        <input
          type="text"
          placeholder="Buscar proveedor y presiona Enter..."
          value={inputBusqueda}
          onChange={(e) =>
            setInputBusqueda(
              e.target.value
            )
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setBusqueda(
                inputBusqueda
              );
            }
          }}
          style={{
            width: "100%",
            maxWidth: 400,
            padding: 12,
            borderRadius: 10,
            border:
              "1px solid #ccc",
            fontSize: 16
          }}
        />
      </div>

      {/* ================================= */}
      {/* TARJETAS */}
      {/* ================================= */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(320px,1fr))",
          gap: 20
        }}
      >
        {productosStats.map(
          (producto, index) => (
            <div
              key={index}
              style={{
                border:
                  "1px solid #ddd",
                borderRadius: 12,
                padding: 20,
                background: "#fff",
                boxShadow:
                  "0 2px 8px rgba(0,0,0,0.1)"
              }}
            >
              {/* PRODUCTO */}
              <h2
                style={{
                  marginBottom: 10,
                  color: "#222"
                }}
              >
                {producto.nombre}
              </h2>

              {/* PROVEEDORES */}
              <p
                style={{
                  marginBottom: 20,
                  color: "#555"
                }}
              >
                <strong>
                  Proveedores:
                </strong>{" "}
                {Array.isArray(
                  producto.proveedores
                )
                  ? producto.proveedores.join(
                      ", "
                    )
                  : producto.proveedores ||
                    "Sin proveedores"}
              </p>

              {/* SEMANAL */}
              <div
                style={{
                  padding: 14,
                  marginBottom: 12,
                  background:
                    "#e3f2fd",
                  borderRadius: 8,
                  fontSize: 18
                }}
              >
                <strong>
                  Venta semanal:
                </strong>{" "}
                {producto.semanal}
              </div>

              {/* MENSUAL */}
              <div
                style={{
                  padding: 14,
                  background:
                    "#e8f5e9",
                  borderRadius: 8,
                  fontSize: 18
                }}
              >
                <strong>
                  Venta mensual:
                </strong>{" "}
                {producto.mensual}
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default Proveedores;